/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const actions = {
  updateBillItems({ commit }, billItem) {
    commit('UPDATE_BILLITEMS', billItem);
  },
  doctorList({ commit }, doctorlist) {
    commit('UPDATE_DOCTORLIST', doctorlist);
  },
    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////
    updateOpDashbaord({ commit }, opList) {
      commit('UPDATE_OPDASHBOARD', opList);
    },
    updateSavedOpData({ commit }, opData) {
      commit('UPDATE_SAVEDOP', opData);
    },
    updateSidebarWidth({ commit }, width) {
      commit('UPDATE_SIDEBAR_WIDTH', width);
    },

    updateOpData({ commit }, data) {
      commit('UPDATE_OPDATA', data);
    },
    updatePatientId({ commit }, patientId) {
      commit('UPDATE_PATIENT_ID', patientId);
    },
      updateIpNo({ commit }, ipNo) {
        commit('UPDATE_IP_NO', ipNo);
    },
    updateBookedRoomDetails({ commit }, bookedRoomDetails) {
      commit('UPDATE_BOOKEDROOMDETAILS', bookedRoomDetails);
    },
    updateBackOpFlag({ commit }, opFlag) {
      commit('UPDATE_BACKOPFLAG', opFlag);
    },
    
    updateI18nLocale({ commit }, locale) {
      commit('UPDATE_I18N_LOCALE', locale);
    },
    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY');
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val);
    },
    updateUserRole({ commit }, val) {
      commit('UPDATE_USER_ROLE', val);
    },
    updateWindowWidth({ commit }, width) {
      commit('UPDATE_WINDOW_WIDTH', width);
    },
    setUserModules({ commit }, modules) {
    commit("SET_USER_MODULES", modules)
  },

    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },
}

export default actions
